import { render, staticRenderFns } from "./lugares-instalacion.vue?vue&type=template&id=518b391c&scoped=true"
import script from "./lugares-instalacion.vue?vue&type=script&lang=js"
export * from "./lugares-instalacion.vue?vue&type=script&lang=js"
import style0 from "./lugares-instalacion.vue?vue&type=style&index=0&id=518b391c&prod&scoped=true&lang=css"
import style1 from "./lugares-instalacion.vue?vue&type=style&index=1&id=518b391c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518b391c",
  null
  
)

export default component.exports